import type {
  FilterSouscriptionType,
  SouscriptionDto,
  SouscriptionWithUserSchemaAndPaymentType,
} from "@reactive-resume/dto";
import { useQuery } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";
import { axios } from "@/client/libs/axios";
import qs from "qs";

export const fetchAllSouscriptions = async (
  page?: number,
  filter?: FilterSouscriptionType | null,
) => {
  if (filter) {
    const response = await axios.get<
      { page: number; data: SouscriptionWithUserSchemaAndPaymentType[] },
      AxiosResponse<{ page: number; data: SouscriptionWithUserSchemaAndPaymentType[] }>
    >("/souscription", {
      params: {
        page,
        ...filter,
      },
      paramsSerializer: (param) => {
        return qs.stringify(param);
      },
    });

    return response.data;
  }

  const response = await axios.get<
    { page: number; data: SouscriptionWithUserSchemaAndPaymentType[] },
    AxiosResponse<{ page: number; data: SouscriptionWithUserSchemaAndPaymentType[] }>
  >("/souscription", {
    params: {
      page,
    },
  });

  return response.data;
};

export const fetchSouscriptionById = async (id: string) => {
  const response = await axios.get<SouscriptionDto, AxiosResponse<SouscriptionDto>>(
    `/souscription/${id}`,
  );

  return response.data;
};

export const useSouscriptions = (page?: number, filter?: FilterSouscriptionType | null) => {
  const {
    error,
    isPending: loading,
    data: souscriptions,
  } = useQuery({
    queryKey: ["souscriptions", page, filter],
    queryFn: () => fetchAllSouscriptions(page, filter),
  });

  return { souscriptions, loading, error };
};

export const useSouscription = (id: string) => {
  const {
    error,
    isPending: loading,
    data: souscription,
  } = useQuery({
    queryKey: ["souscription", id],
    queryFn: () => fetchSouscriptionById(id),
    enabled: !!id,
  });

  return { souscription, loading, error };
};
